import React, { useEffect, useState, useContext } from "react";
import StudentParticipation from "./Dounut";
import GradeWiseParticipation from "./GradewiseParticipation";
import axiosInstance from "../../../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import { LoadContext } from "../../../ReusableComponents/LoadingContex";

const Participation = () => {
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
    const USYear = useSelector((state) => state.SelecYearData.SYear);
    const { SetLoad } = useContext(LoadContext);
    const [RPCount, SetRPCount] = useState();
    const [TotalData, SeTotalData] = useState();
    const GetParticipationCount = async () => {
        SetLoad(true);
        try {
            const res = await axiosInstance.get(`/Principal/GetSubjectGradeWiseParticipationReport?SchoolId=${items.schoolId}&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}`);
            const totals = res.data.reduce((acc, item) => {
                acc.registered += item.registered;
                acc.participated += item.participated;
                return acc;
            },
                { registered: 0, participated: 0, }
            );
            SetRPCount(totals);
            SeTotalData(res.data);
            SetLoad(false);
        }
        catch (err) { console.log(err); SetLoad(false); }
    }
    useEffect(() => {
        GetParticipationCount();
    }, [USYear,SelectDate])
    return (
        <>
            <div>
                <StudentParticipation PRCount={RPCount} />
                {TotalData && <GradeWiseParticipation Data={TotalData} />}
            </div>
        </>
    )
}
export default Participation;